<div 
*ngIf="!isLoading"
class="flex justify-center items-center gap-5 w-full h-full text-[1.2rem] xl:text-[1.4rem] 2xl:text-[1.75rem]">

  <div class="flex flex-col gap-4 items-center justify-center text-dimot-1 flex-1">
    <h2 class="text-[2.5rem] xl:text-[2.9rem] 2xl:text-[3.4rem] text-center">
      {{ formatNumber(experienceAndHospitals!.hosptialsTotalNumber) }}
    </h2>
    <h3 class="mb-2 text-[0.9rem] xl:text-[1rem] 2xl:text-[1.1rem] text-center">
      Centri Ospedalieri
    </h3>
  </div>


  <div class="w-[1px] h-[90%] mt-4  bg-gray-200"></div>


  <div class="flex flex-col gap-4 items-center justify-center text-dimot-1 flex-1">
    <h2 class="text-[2.5rem] xl:text-[2.9rem] 2xl:text-[3.4rem] text-center">
      {{ formatNumber(experienceAndHospitals.experienceTotal ) }}
    </h2>
    <h3 class="mb-2 text-[0.9rem] xl:text-[1rem] 2xl:text-[1.1rem] text-center">
      Esperienze
    </h3>
  </div>

</div>

<!--<div 
*ngIf="!isLoading"
class="flex flex-col justify-center items-center gap-16 w-full h-[490px] text-[1.75rem]">

  <div class="flex flex-col items-center text-dimot-1">
    <h2 class="text-[3.8rem]">
      {{ formatNumber(experienceAndHospitals!.hosptialsTotalNumber) }}
    </h2>
    <h3 class="mb-2 text-[1.4rem]">
      Numero Centri Ospedalieri
    </h3>
  </div>

  <div class="w-full flex justify-center">
    <div class="w-[100%] h-[1px] bg-gray-200"></div>
  </div>

  <div class="flex flex-col items-center text-dimot-1">
    <h2 class="text-[3.8rem]">
      {{ formatNumber(experienceAndHospitals.experienceTotal ) }}
    </h2>
    <h3 class="mb-2 text-[1.4rem]">
      Numero Esperienze
    </h3>
  </div>

</div>

-->
